export const GET_SVG = 'GET_SVG';
export const DOWNLOAD_STAGE = 'DOWNLOAD_STAGE'